import classNames from "classnames";
import React, { useState, createRef } from "react";
import { useClasses } from "../../";
import Field from "./Shared/Field";
import Menu from "./Shared/Menu";
import Input, { styles } from "./Shared/Input";
const style = (theme) => {
    const inputStyles = styles(theme);
    return {
        inputHolder: inputStyles.inputHolder,
        inlineHolder: {
            "@media print": {
                padding: "18px 0px 0px 0px",
            },
        },
        input: {
            ...inputStyles.input,
            paddingRight: "35px",
            cursor: "pointer",
        },
        helpBlock: {
            fontSize: "0.8rem",
            lineHeight: "0.8rem",
            color: "rgba(0, 0, 0, 0.75)",
        },
        hasError: inputStyles.hasError,
        indicatorHolder: {
            textAlign: "right",
            "@media print": {
                display: "none",
            },
        },
        indicator: {
            position: "absolute",
            cursor: "pointer",
            width: 0,
            height: 0,
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderTop: `8px solid #797979`,
            margin: "12px 0px 0px -25px",
            "@media print": {
                display: "none",
            },
        },
        indicatorOpen: {
            position: "absolute",
            cursor: "pointer",
            width: 0,
            height: 0,
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderBottom: `8px solid #797979`,
            margin: "12px 0px 0px -25px",
            "@media print": {
                display: "none",
            },
        },
        list: {
            padding: "0px",
            margin: "0px",
            listStyle: "none",
        },
        listElement: {
            cursor: "pointer",
            height: "32px",
            lineHeight: "32px",
            margin: "0px -16px",
            padding: "5px 24px  5px 24px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            "&:hover": {
                backgroundColor: theme.palette.get("primary"),
                color: "#fff",
            },
        },
        search: {
            marginBottom: "16px",
        },
    };
};
const Select = (props) => {
    var _a, _b, _c;
    const classes = useClasses(style);
    const { inline = false, value, error } = props;
    const hasValue = Boolean(value);
    const [isFocused] = useState(false);
    const [isOpen, setOpen] = useState(false);
    const [inputRef] = useState(createRef());
    const [search, setSearch] = useState();
    let options = props.options;
    if (search)
        options = options.filter((item) => item.label
            .toLocaleLowerCase()
            .includes((search || "").toLocaleLowerCase()));
    const hasError = Boolean(error);
    return (React.createElement(Field, { label: props.label, readOnly: props.readOnly, open: props.open, inline: props.inline, hasValue: hasValue, info: props.info, error: props.error, isFocused: isFocused, autoComplete: props.autoComplete, override: props.override, onLabelClick: () => setOpen(!isOpen) },
        React.createElement("div", { className: classNames([
                inline ? classes.inlineHolder : classes.inputHolder,
            ]) },
            React.createElement("div", { className: classes.indicatorHolder },
                React.createElement("span", { className: classNames([
                        isOpen ? classes.indicatorOpen : classes.indicator,
                        isOpen
                            ? (_a = props.override) === null || _a === void 0 ? void 0 : _a.indicatorOpen
                            : (_b = props.override) === null || _b === void 0 ? void 0 : _b.indicator,
                    ]), onClick: () => setOpen(!isOpen) })),
            React.createElement("div", { className: classNames([
                    classes.input,
                    hasError && classes.inputError,
                    (_c = props.override) === null || _c === void 0 ? void 0 : _c.input,
                ]), ref: inputRef, onClick: () => {
                    setOpen(!isOpen);
                    if (props.onClick)
                        props.onClick();
                } }, (props.options.find((item) => item.value && item.value === value) ||
                {}).label || ""),
            isOpen && (React.createElement(Menu, { searchAble: props.searchAble, searchLable: props.searchLabel, anchor: inputRef, onClose: () => setOpen(false), onFocus: props.onFocus, onBlur: props.onBlur, override: props.override },
                React.createElement("ul", { className: classes.list },
                    Boolean(props.searchAble) && (React.createElement("li", { className: classes.search },
                        React.createElement(Input, { inline: true, autoFocus: true, placeholder: "Search", value: search || "", onChange: (value) => {
                                setSearch(value || undefined);
                            }, rows: 0, type: "text", setFocus: () => { }, hasError: false }))),
                    Boolean(options.length) &&
                        options.map((option) => (React.createElement("li", { key: option.value, className: classes.listElement, onClick: (e) => {
                                if (props.onChange)
                                    props.onChange(option.value);
                                setOpen(false);
                            } }, option.label))),
                    !options.length && (React.createElement("li", { className: classes.listElement }, props.noneFound))))))));
};
export default Select;
